<script setup>
import TelegramLogo from "@/Components/TelegramLogo.vue";
import Modal from "@/Components/Modal.vue";
import { ref, computed } from "vue";
import { usePage, useForm } from '@inertiajs/vue3';
import axios from "axios"
import { usePosthog } from "@/plugins/posthog.js";

const posthog = usePosthog();
const page = usePage();
const strings = computed(() => page.props.strings);
const showingModal = ref(false);
const showingFeedbackReceived = ref(false);

const form = useForm({
    type: 'bug',
    comment: '',
});

const submit = () => {
    if (!form.type || !form.comment) {
        return;
    }
    
    axios.post(route('feedback.store'), {
        type: form.type,
        comment: form.comment,
    }).then(() => {
        showingFeedbackReceived.value = true;
        setTimeout(() => {
            showingFeedbackReceived.value = false;
            showingModal.value = false;
        }, 3000);
        form.reset('comment');
        if (posthog) {
            posthog.capture("Sent Feedback");
        }
    });
};
</script>

<template>
    <div class="z-50 fixed bottom-4 right-4 flex items-center justify-center w-10 h-10">
        <button @click="showingModal = true" class="inline-flex items-center justify-center rounded-full w-10 h-10 bg-blue-600 text-white font-black">
            <span class="text-xl">?</span>
        </button>

        <Modal
            :show="showingModal"
            @close="showingModal = false"
            :bottom="false"
        >
            <div v-if="showingFeedbackReceived">{{ strings['feedback_form_confirmation'] }}</div>
            <div v-else class="space-y-6 py-6">
                <form @submit.prevent="submit" class="space-y-4">
                    <div>
                        <label for="feedback_type" class="block text-sm font-medium leading-6 text-gray-900">{{ strings['feedback_form_comment_label'] }}</label>
                        <select id="feedback_type" name="type" v-model="form.type" class="text-sm mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                            <option value="bug">{{ strings['feedback_form_type_bug'] }}</option>
                            <option value="feature">{{ strings['feedback_form_type_feature'] }}</option>
                            <option value="question">{{ strings['feedback_form_type_question'] }}</option>
                        </select>
                    </div>

                    <div>
                        <label for="feedback_comment" class="block text-sm font-medium leading-6 text-gray-900">{{ strings['feedback_form_comment_label'] }}</label>
                        <div class="mt-2">
                            <textarea v-model="form.comment" rows="5" name="comment" id="feedback_comment" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
                        </div>
                    </div>

                    <div>
                        <button type="submit" class="px-3 py-1.5 bg-blue-700 rounded text-white font-semibold text-sm">{{ strings['feedback_form_send'] }}</button>
                    </div>
                </form>

                <div>
                    <div class="text-gray-600 text-sm mb-4">{{ strings['login_or'] }}</div>
                    <div class="flex items-center space-x-2">
                        <TelegramLogo class="h-6 w-6" />
                        <a href="https://t.me/+iApnwJFW4fg3ODU0" target="_blank">{{ strings['feedback_form_telegram'] }}</a>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>
